import { Button } from "@/components/button"
import { MoveRightIcon } from "@/domains/icons"
import { cn } from "@/domains/library"

type BackLinkProps = {
  onBackLinkClick: () => void
  className?: string
}

export const BackLink = ({ onBackLinkClick, className }: BackLinkProps) => {
  return (
    <Button
      variant="link-secondary"
      onClick={() => onBackLinkClick()}
      className={cn("flex-inline items-center gap-1", className)}
    >
      Back
      <MoveRightIcon size={16} className="ml-[4px]" />
    </Button>
  )
}
